/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Phoenix | v1
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  GetWebFilterPlacementOrderResponse,
  GetWebFilterResponse,
  GetWwwWebFilterPlacementOrderParams,
  ListRequest,
  ListResponseOfWebFilterDestinationSuggestion,
  ListResponseOfWebFilterListItem,
  ListResponseOfWebFilterProductSuggestion,
  ListResponseOfWebFilterStationSuggestion,
  ListWwwWebProjectsParams,
  ProblemDetails,
  UploadWebFilterFileResponse,
  UploadWwwWebFilterFileBody,
  WebFilterWriteRequest,
  WebFilterWriteResponse,
  WebProjectListItem
} from '.././schemas';

import { customInstance } from '../../customInstance';
import type { ErrorType } from '../../customInstance';




export const createWwwWebFilter = (
    webFilterWriteRequest: WebFilterWriteRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<WebFilterWriteResponse>(
      {url: `/api/www/web-filters`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: webFilterWriteRequest, signal
    },
      );
    }
  


export const getCreateWwwWebFilterMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createWwwWebFilter>>, TError,{data: WebFilterWriteRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createWwwWebFilter>>, TError,{data: WebFilterWriteRequest}, TContext> => {

const mutationKey = ['createWwwWebFilter'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createWwwWebFilter>>, {data: WebFilterWriteRequest}> = (props) => {
          const {data} = props ?? {};

          return  createWwwWebFilter(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateWwwWebFilterMutationResult = NonNullable<Awaited<ReturnType<typeof createWwwWebFilter>>>
    export type CreateWwwWebFilterMutationBody = WebFilterWriteRequest
    export type CreateWwwWebFilterMutationError = ErrorType<unknown>

    export const useCreateWwwWebFilter = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createWwwWebFilter>>, TError,{data: WebFilterWriteRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createWwwWebFilter>>,
        TError,
        {data: WebFilterWriteRequest},
        TContext
      > => {

      const mutationOptions = getCreateWwwWebFilterMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const getWwwWebFilterDestinationSuggestions = (
    listRequest: ListRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<ListResponseOfWebFilterDestinationSuggestion>(
      {url: `/api/www/web-filters/destinations`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: listRequest, signal
    },
      );
    }
  


export const getGetWwwWebFilterDestinationSuggestionsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getWwwWebFilterDestinationSuggestions>>, TError,{data: ListRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof getWwwWebFilterDestinationSuggestions>>, TError,{data: ListRequest}, TContext> => {

const mutationKey = ['getWwwWebFilterDestinationSuggestions'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getWwwWebFilterDestinationSuggestions>>, {data: ListRequest}> = (props) => {
          const {data} = props ?? {};

          return  getWwwWebFilterDestinationSuggestions(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type GetWwwWebFilterDestinationSuggestionsMutationResult = NonNullable<Awaited<ReturnType<typeof getWwwWebFilterDestinationSuggestions>>>
    export type GetWwwWebFilterDestinationSuggestionsMutationBody = ListRequest
    export type GetWwwWebFilterDestinationSuggestionsMutationError = ErrorType<unknown>

    export const useGetWwwWebFilterDestinationSuggestions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getWwwWebFilterDestinationSuggestions>>, TError,{data: ListRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getWwwWebFilterDestinationSuggestions>>,
        TError,
        {data: ListRequest},
        TContext
      > => {

      const mutationOptions = getGetWwwWebFilterDestinationSuggestionsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const uploadWwwWebFilterFile = (
    uploadWwwWebFilterFileBody: UploadWwwWebFilterFileBody,
 signal?: AbortSignal
) => {
      
      const formData = new FormData();
if(uploadWwwWebFilterFileBody.webProjectId !== undefined) {
 formData.append(`webProjectId`, uploadWwwWebFilterFileBody.webProjectId.toString())
 }

if(uploadWwwWebFilterFileBody.slot !== undefined) {
 formData.append(`slot`, uploadWwwWebFilterFileBody.slot)
 }

if(uploadWwwWebFilterFileBody.file !== undefined) {
 formData.append(`file`, uploadWwwWebFilterFileBody.file)
 }

      return customInstance<UploadWebFilterFileResponse>(
      {url: `/api/www/web-filters/files`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData, signal
    },
      );
    }
  


export const getUploadWwwWebFilterFileMutationOptions = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadWwwWebFilterFile>>, TError,{data: UploadWwwWebFilterFileBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof uploadWwwWebFilterFile>>, TError,{data: UploadWwwWebFilterFileBody}, TContext> => {

const mutationKey = ['uploadWwwWebFilterFile'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof uploadWwwWebFilterFile>>, {data: UploadWwwWebFilterFileBody}> = (props) => {
          const {data} = props ?? {};

          return  uploadWwwWebFilterFile(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UploadWwwWebFilterFileMutationResult = NonNullable<Awaited<ReturnType<typeof uploadWwwWebFilterFile>>>
    export type UploadWwwWebFilterFileMutationBody = UploadWwwWebFilterFileBody
    export type UploadWwwWebFilterFileMutationError = ErrorType<ProblemDetails>

    export const useUploadWwwWebFilterFile = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadWwwWebFilterFile>>, TError,{data: UploadWwwWebFilterFileBody}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof uploadWwwWebFilterFile>>,
        TError,
        {data: UploadWwwWebFilterFileBody},
        TContext
      > => {

      const mutationOptions = getUploadWwwWebFilterFileMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const wwwWebFilterList = (
    listRequest: ListRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<ListResponseOfWebFilterListItem>(
      {url: `/api/www/web-filters/list`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: listRequest, signal
    },
      );
    }
  


export const getWwwWebFilterListMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof wwwWebFilterList>>, TError,{data: ListRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof wwwWebFilterList>>, TError,{data: ListRequest}, TContext> => {

const mutationKey = ['wwwWebFilterList'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof wwwWebFilterList>>, {data: ListRequest}> = (props) => {
          const {data} = props ?? {};

          return  wwwWebFilterList(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type WwwWebFilterListMutationResult = NonNullable<Awaited<ReturnType<typeof wwwWebFilterList>>>
    export type WwwWebFilterListMutationBody = ListRequest
    export type WwwWebFilterListMutationError = ErrorType<unknown>

    export const useWwwWebFilterList = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof wwwWebFilterList>>, TError,{data: ListRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof wwwWebFilterList>>,
        TError,
        {data: ListRequest},
        TContext
      > => {

      const mutationOptions = getWwwWebFilterListMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const getWwwWebFilterPlacementOrder = (
    params: GetWwwWebFilterPlacementOrderParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetWebFilterPlacementOrderResponse>(
      {url: `/api/www/web-filters/placement-order`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getGetWwwWebFilterPlacementOrderQueryKey = (params?: GetWwwWebFilterPlacementOrderParams,) => {
    return [
    `/api/www/web-filters/placement-order`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetWwwWebFilterPlacementOrderQueryOptions = <TData = Awaited<ReturnType<typeof getWwwWebFilterPlacementOrder>>, TError = ErrorType<unknown>>(params: GetWwwWebFilterPlacementOrderParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWwwWebFilterPlacementOrder>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetWwwWebFilterPlacementOrderQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getWwwWebFilterPlacementOrder>>> = ({ signal }) => getWwwWebFilterPlacementOrder(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getWwwWebFilterPlacementOrder>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetWwwWebFilterPlacementOrderQueryResult = NonNullable<Awaited<ReturnType<typeof getWwwWebFilterPlacementOrder>>>
export type GetWwwWebFilterPlacementOrderQueryError = ErrorType<unknown>


export function useGetWwwWebFilterPlacementOrder<TData = Awaited<ReturnType<typeof getWwwWebFilterPlacementOrder>>, TError = ErrorType<unknown>>(
 params: GetWwwWebFilterPlacementOrderParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWwwWebFilterPlacementOrder>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWwwWebFilterPlacementOrder>>,
          TError,
          Awaited<ReturnType<typeof getWwwWebFilterPlacementOrder>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetWwwWebFilterPlacementOrder<TData = Awaited<ReturnType<typeof getWwwWebFilterPlacementOrder>>, TError = ErrorType<unknown>>(
 params: GetWwwWebFilterPlacementOrderParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWwwWebFilterPlacementOrder>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWwwWebFilterPlacementOrder>>,
          TError,
          Awaited<ReturnType<typeof getWwwWebFilterPlacementOrder>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetWwwWebFilterPlacementOrder<TData = Awaited<ReturnType<typeof getWwwWebFilterPlacementOrder>>, TError = ErrorType<unknown>>(
 params: GetWwwWebFilterPlacementOrderParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWwwWebFilterPlacementOrder>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetWwwWebFilterPlacementOrder<TData = Awaited<ReturnType<typeof getWwwWebFilterPlacementOrder>>, TError = ErrorType<unknown>>(
 params: GetWwwWebFilterPlacementOrderParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWwwWebFilterPlacementOrder>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetWwwWebFilterPlacementOrderQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getWwwWebFilterProductSuggestions = (
    listRequest: ListRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<ListResponseOfWebFilterProductSuggestion>(
      {url: `/api/www/web-filters/products`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: listRequest, signal
    },
      );
    }
  


export const getGetWwwWebFilterProductSuggestionsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getWwwWebFilterProductSuggestions>>, TError,{data: ListRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof getWwwWebFilterProductSuggestions>>, TError,{data: ListRequest}, TContext> => {

const mutationKey = ['getWwwWebFilterProductSuggestions'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getWwwWebFilterProductSuggestions>>, {data: ListRequest}> = (props) => {
          const {data} = props ?? {};

          return  getWwwWebFilterProductSuggestions(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type GetWwwWebFilterProductSuggestionsMutationResult = NonNullable<Awaited<ReturnType<typeof getWwwWebFilterProductSuggestions>>>
    export type GetWwwWebFilterProductSuggestionsMutationBody = ListRequest
    export type GetWwwWebFilterProductSuggestionsMutationError = ErrorType<unknown>

    export const useGetWwwWebFilterProductSuggestions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getWwwWebFilterProductSuggestions>>, TError,{data: ListRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getWwwWebFilterProductSuggestions>>,
        TError,
        {data: ListRequest},
        TContext
      > => {

      const mutationOptions = getGetWwwWebFilterProductSuggestionsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const getWwwWebFilterStationSuggestions = (
    listRequest: ListRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<ListResponseOfWebFilterStationSuggestion>(
      {url: `/api/www/web-filters/stations`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: listRequest, signal
    },
      );
    }
  


export const getGetWwwWebFilterStationSuggestionsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getWwwWebFilterStationSuggestions>>, TError,{data: ListRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof getWwwWebFilterStationSuggestions>>, TError,{data: ListRequest}, TContext> => {

const mutationKey = ['getWwwWebFilterStationSuggestions'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getWwwWebFilterStationSuggestions>>, {data: ListRequest}> = (props) => {
          const {data} = props ?? {};

          return  getWwwWebFilterStationSuggestions(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type GetWwwWebFilterStationSuggestionsMutationResult = NonNullable<Awaited<ReturnType<typeof getWwwWebFilterStationSuggestions>>>
    export type GetWwwWebFilterStationSuggestionsMutationBody = ListRequest
    export type GetWwwWebFilterStationSuggestionsMutationError = ErrorType<unknown>

    export const useGetWwwWebFilterStationSuggestions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getWwwWebFilterStationSuggestions>>, TError,{data: ListRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getWwwWebFilterStationSuggestions>>,
        TError,
        {data: ListRequest},
        TContext
      > => {

      const mutationOptions = getGetWwwWebFilterStationSuggestionsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const updateWwwWebFilter = (
    id: string,
    webFilterWriteRequest: WebFilterWriteRequest,
 ) => {
      
      
      return customInstance<WebFilterWriteResponse>(
      {url: `/api/www/web-filters/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: webFilterWriteRequest
    },
      );
    }
  


export const getUpdateWwwWebFilterMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateWwwWebFilter>>, TError,{id: string;data: WebFilterWriteRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateWwwWebFilter>>, TError,{id: string;data: WebFilterWriteRequest}, TContext> => {

const mutationKey = ['updateWwwWebFilter'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateWwwWebFilter>>, {id: string;data: WebFilterWriteRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  updateWwwWebFilter(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateWwwWebFilterMutationResult = NonNullable<Awaited<ReturnType<typeof updateWwwWebFilter>>>
    export type UpdateWwwWebFilterMutationBody = WebFilterWriteRequest
    export type UpdateWwwWebFilterMutationError = ErrorType<unknown>

    export const useUpdateWwwWebFilter = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateWwwWebFilter>>, TError,{id: string;data: WebFilterWriteRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateWwwWebFilter>>,
        TError,
        {id: string;data: WebFilterWriteRequest},
        TContext
      > => {

      const mutationOptions = getUpdateWwwWebFilterMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const getWwwWebFilter = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetWebFilterResponse>(
      {url: `/api/www/web-filters/${id}`, method: 'GET', signal
    },
      );
    }
  



export const getGetWwwWebFilterQueryKey = (id?: string,) => {
    return [
    `/api/www/web-filters/${id}`
    ] as const;
    }

    
export const getGetWwwWebFilterQueryOptions = <TData = Awaited<ReturnType<typeof getWwwWebFilter>>, TError = ErrorType<void>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWwwWebFilter>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetWwwWebFilterQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getWwwWebFilter>>> = ({ signal }) => getWwwWebFilter(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getWwwWebFilter>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetWwwWebFilterQueryResult = NonNullable<Awaited<ReturnType<typeof getWwwWebFilter>>>
export type GetWwwWebFilterQueryError = ErrorType<void>


export function useGetWwwWebFilter<TData = Awaited<ReturnType<typeof getWwwWebFilter>>, TError = ErrorType<void>>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWwwWebFilter>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWwwWebFilter>>,
          TError,
          Awaited<ReturnType<typeof getWwwWebFilter>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetWwwWebFilter<TData = Awaited<ReturnType<typeof getWwwWebFilter>>, TError = ErrorType<void>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWwwWebFilter>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWwwWebFilter>>,
          TError,
          Awaited<ReturnType<typeof getWwwWebFilter>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetWwwWebFilter<TData = Awaited<ReturnType<typeof getWwwWebFilter>>, TError = ErrorType<void>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWwwWebFilter>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetWwwWebFilter<TData = Awaited<ReturnType<typeof getWwwWebFilter>>, TError = ErrorType<void>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWwwWebFilter>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetWwwWebFilterQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const deleteWwwWebFilter = (
    id: string,
 ) => {
      
      
      return customInstance<void>(
      {url: `/api/www/web-filters/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteWwwWebFilterMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteWwwWebFilter>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteWwwWebFilter>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteWwwWebFilter'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteWwwWebFilter>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteWwwWebFilter(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteWwwWebFilterMutationResult = NonNullable<Awaited<ReturnType<typeof deleteWwwWebFilter>>>
    
    export type DeleteWwwWebFilterMutationError = ErrorType<unknown>

    export const useDeleteWwwWebFilter = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteWwwWebFilter>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteWwwWebFilter>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteWwwWebFilterMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const listWwwWebProjects = (
    params?: ListWwwWebProjectsParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<WebProjectListItem[]>(
      {url: `/api/www/web-projects`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getListWwwWebProjectsQueryKey = (params?: ListWwwWebProjectsParams,) => {
    return [
    `/api/www/web-projects`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getListWwwWebProjectsQueryOptions = <TData = Awaited<ReturnType<typeof listWwwWebProjects>>, TError = ErrorType<unknown>>(params?: ListWwwWebProjectsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listWwwWebProjects>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListWwwWebProjectsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listWwwWebProjects>>> = ({ signal }) => listWwwWebProjects(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listWwwWebProjects>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListWwwWebProjectsQueryResult = NonNullable<Awaited<ReturnType<typeof listWwwWebProjects>>>
export type ListWwwWebProjectsQueryError = ErrorType<unknown>


export function useListWwwWebProjects<TData = Awaited<ReturnType<typeof listWwwWebProjects>>, TError = ErrorType<unknown>>(
 params: undefined |  ListWwwWebProjectsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listWwwWebProjects>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listWwwWebProjects>>,
          TError,
          Awaited<ReturnType<typeof listWwwWebProjects>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListWwwWebProjects<TData = Awaited<ReturnType<typeof listWwwWebProjects>>, TError = ErrorType<unknown>>(
 params?: ListWwwWebProjectsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listWwwWebProjects>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listWwwWebProjects>>,
          TError,
          Awaited<ReturnType<typeof listWwwWebProjects>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListWwwWebProjects<TData = Awaited<ReturnType<typeof listWwwWebProjects>>, TError = ErrorType<unknown>>(
 params?: ListWwwWebProjectsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listWwwWebProjects>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListWwwWebProjects<TData = Awaited<ReturnType<typeof listWwwWebProjects>>, TError = ErrorType<unknown>>(
 params?: ListWwwWebProjectsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listWwwWebProjects>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListWwwWebProjectsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




